import {
  FrameworkExceptions,
  FrameworkExceptionsProps,
} from "~/pages/compliance/Framework/FrameworkOutlets";

const FrameworkExceptionsEntryPage = ({}: FrameworkExceptionsProps) => {
  return <FrameworkExceptions />;
};

export default FrameworkExceptionsEntryPage;
